import { config } from "@lib/config";
import { BudgetCheckStepId } from "@modules/application/lib/budgetCheck/types";
import BudgetCheck from "@modules/application/pages/BudgetCheck";
import { GetStaticPaths, GetStaticProps, NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";

interface BudgetCheckPageProps {
  stepId: string;
}

const BudgetCheckPage: NextPage<BudgetCheckPageProps> = ({ stepId }) => {
  return (
    <>
      <Head>
        <title>Justhome - Budget Check</title>
      </Head>
      <BudgetCheck stepId={stepId} />
    </>
  );
};

export default BudgetCheckPage;

export const getStaticPaths: GetStaticPaths = (context) => {
  const paths =
    context.locales
      ?.map((locale: string) =>
        Object.values(BudgetCheckStepId).map((stepId) => ({
          params: {
            stepId,
          },
          locale: locale,
        })),
      )
      .flat() || [];

  return { paths, fallback: false };
};

export const getStaticProps: GetStaticProps = async ({ locale, params }) => {
  return {
    props: {
      stepId: params?.stepId,
      ...(await serverSideTranslations(locale!)),
    },
    revalidate: config.cms.revalidate,
  };
};
